export default {
  title: {
    en: 'Your subscription was cancelled',
  },
  text: {
    en: `
    Dear {userName}. We sucessfully cancelled your subscription. You'll still receive all products for the 
    duration of your plan, since we don't offer refunds. Once your subscription expires, we will end your service. 
    If, at any time, you change your mind, you'll need to resubscribe at a later date.
  `,
  },
  resubscribeButton: {
    en: 'Resubscribe',
  },
  resubscribeQuestion: {
    en: 'How likely are you to resubscribe in the future?',
  },
}
